import { Outlet } from 'react-router';

import { AppLayout } from '../../app-layout';

export const NotRequireAuth = () => (
  <AppLayout isForLogged={false}>
    <Outlet />
  </AppLayout>
);
